import type { DataGaps } from "../../../../../../../../utils/backend-types";
import type { Frequency } from "../../../../../../../../utils/enums";
import type { DataGapsTableObject } from "../DataGaps.types";
import { getTableObjectsFromDataGapEntry } from "./getTableObjectFromDataGapEntry";

export function getTableDataFromDataGaps(
  dataGaps: DataGaps,
  frequency: Frequency
): Array<DataGapsTableObject> {
  const tableData: Array<DataGapsTableObject> = [];
  Object.keys(dataGaps).forEach((measurand) => {
    if (measurand !== "expectedOrigin") {
      const dataObjects = getTableObjectsFromDataGapEntry(
        dataGaps[measurand],
        frequency
      );
      if (dataObjects) {
        tableData.push(...dataObjects);
      }
    }
  });
  return tableData;
}
